<template>
  <div class="state">
    <div class="state-box">
      <div class="state-left">
        <div class="resources-date">
          <img src="~@/assets/image/common/common_date.png" alt="">
          <time>
            <strong>{{ resourcesObj ? resourcesObj.friendlyDate : '' }}</strong>
            <span>{{ resourcesObj ? resourcesObj.date : '' }}</span>
          </time>
        </div>
        <div class="resources-box" v-if="resourcesObj">
          <span v-for="(item, index) in detailList" :class="{ 'noTicket': !item.highlight }" :key="index">{{ item.name }}:{{ item.showStatus }}</span>
        </div>
      </div>
      <div class="state-right">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "state",
  props:['resourcesObj'],
  data() {
    return {
      detailList: []
    }
  },
  watch: {
    resourcesObj: {
      handler(newValue){
        const { detailList } = newValue;
        detailList.forEach(item => {
          item.highlight = false;
          if(!item.expiredFlag){
            if(!item.sellOutFlag){
              item.showStatus = '有余票';
              item.highlight = true;
            }else{
              item.showStatus = '已售罄';
            }
          }else{
            item.showStatus = '已止票';
          }
        });
        this.detailList = detailList;
      },
      immediate: true,
    }
  }
};
</script>

<style scoped lang='less'>
.noTicket {
  background: rgba(255, 255, 255, 0.49) !important;
  color: #FFFFFF !important;
}
.state {
  position: relative;
  .state-box{
    height: 1.8667rem;
    position: absolute;
    width: 100%;
    left: 0;
    top: -1.8667rem;
    background: linear-gradient(180deg, rgba(14, 13, 13, 0.66) 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 0 0 .213333rem .213333rem;
    padding: .2rem .333333rem;
    display: flex;
    justify-content: space-between;
  }
  .state-left{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .resources-date{
      display: flex;
      align-items: center;
      img{
        width: .546667rem;
      }
      time{
        color: #fff;
        strong{
          font-size: .48rem;
          font-weight: bold;
          line-height: .666667rem;
          margin: 0 .093333rem 0 .173333rem;
        }
        span{
          font-size: .373333rem;
        }
      }
    }
    .resources-box{
    display: flex;
    justify-content: space-between;
      span{
        padding: 0 .266667rem;
        font-size: .32rem;
        background: #FFFFFF;
        border-radius: .28rem;
        color: #333333;
        line-height: .56rem;
        &:last-child{
          margin-left: .266667rem;
        }
      };
    }
  }

}
</style>
